/* eslint-disable */
const getters = {
  getOrder(state) {
    return state.data;
  },

  getIsLoading(state) {
    return state.isLoading;
  },

  getNotes(state) {
    return state.data.notes;
  },

  getOriginalSendCharge(state) {
    return state.originalSendCharge;
  },
};

export default getters;
